import type {CompRef, VariantPointer} from './componentsObject'

export interface ResolvedFunctions {
    onSuccess(): void
    onError(): void
}

export enum MobileAlgoConditionType {
    Publish = 'publish',
    RevisionSave = 'revision_save',
    Manual = 'manual',
    Unknown = 'unknown'
}

export interface ConversionAlgoConfigOverrides {
    targetVariants?: VariantPointer[]
    sourceCanvasSize?: number
    targetCanvasSize?: number
    debug?: boolean
}

export interface MobileAlgoExecutionOptions {
    conditionType?: MobileAlgoConditionType
}

export interface MobileAlgoApi {
    run(containerPointer: CompRef, resolvedFunctions?: ResolvedFunctions, config?: ConversionAlgoConfigOverrides): void
    runForPage(
        pagePointer: CompRef,
        resolvedFunctions?: ResolvedFunctions,
        config?: ConversionAlgoConfigOverrides
    ): void
    groupings: {
        removeLastGroupingHashFromAllPages(): void
        removeLastGroupingHashFromPage(pagePointer: CompRef): void
        removeLastGroupingHashFromSection(sectionPointer: CompRef): void
        getLastGroupingHash(compRef: CompRef): string | null
    }
    locking: {
        unlockSectionsForAllPages(): void
        unlockSectionsForPage(pagePointer: CompRef): void
        softLock(compPointer: CompRef): void
        softLockPage(compPointer: CompRef): void
    }
    utils: {
        getFontSize(fontStyleEntryItem: string): {
            targetFontSize?: number
            unit?: string
        }
    }
}
